import {TASK_CREATE_FORM_DIALOG_HIDE, TASK_CREATE_FORM_DIALOG_SHOW, TaskCreateFormActions} from './task-create-form.actions';

export interface State {
    dialogShow: boolean;
}

const initialState = {
    dialogShow: false,
};

export function tagTaskCreateReducer(state: State = initialState, action: TaskCreateFormActions) {
    switch (action.type) {
        case TASK_CREATE_FORM_DIALOG_SHOW:
            state = {
                ...state,
                dialogShow: true
            };
            break;
        case TASK_CREATE_FORM_DIALOG_HIDE:
            state = {
                ...state,
                dialogShow: false
            };
            break;
        default:
            state = {
                ...state
            };
    }
    return state;
}
